export const isPermitted = (
  usersPermissions: string[],
  requestedPermissions: string | string[],
  isEveryPermissionRequired = false,
) => {
  if (usersPermissions.includes('*')) {
    return true;
  }
  if (typeof requestedPermissions === 'string') {
    return usersPermissions.includes(requestedPermissions);
  }
  if (isEveryPermissionRequired) {
    return requestedPermissions.every((p) => usersPermissions.includes(p));
  }
  return requestedPermissions.some((p) => usersPermissions.includes(p));
};
